import { contractsApis } from '@shared/apis';
import {
  genericMutation,
  genericMutationWithId,
  genericMutationWithIdParams,
  genericQuery,
  genericQueryWithId,
  genericQueryWithParams,
} from './generics';

export const useSearchContracts = genericQueryWithParams<contractsApis.SearchContracts>(
  contractsApis.searchContracts
);

export const useSearchContractsLight = genericQueryWithParams<contractsApis.SearchContractsLight>(
  contractsApis.searchContractsLight
);

export const useGetContract = genericQueryWithId<contractsApis.GetContract>(
  contractsApis.getContract
);

export const useCreateContract = genericMutation<contractsApis.CreateContract>(
  contractsApis.createContract,
  contractsApis.searchContracts.endpoint,
  contractsApis.getSmartBillSyncStatus.endpoint
);

export const useUpdateContract = genericMutationWithId<contractsApis.UpdateContract>(
  contractsApis.updateContract,
  contractsApis.searchContracts.endpoint,
  contractsApis.getContract.endpoint
);

export const useDeleteContract = genericMutationWithId<contractsApis.DeleteContract>(
  contractsApis.deleteContract,
  contractsApis.searchContracts.endpoint,
  contractsApis.getUnmappedInvoices.endpoint,
  contractsApis.getSmartBillSyncStatus.endpoint
);

export const useAddContractContact = genericMutationWithId<contractsApis.AddContractContact>(
  contractsApis.addContractContact,
  contractsApis.searchContracts.endpoint,
  contractsApis.getContract.endpoint
);

export const useAddContractAddendum = genericMutationWithId<contractsApis.AddContractAddendum>(
  contractsApis.addContractAddendum,
  contractsApis.searchContracts.endpoint,
  contractsApis.getContract.endpoint
);

export const useDeleteContractAddendum =
  genericMutationWithIdParams<contractsApis.DeleteContractAddendum>(
    contractsApis.deleteContractAddendum,
    contractsApis.searchContracts.endpoint,
    contractsApis.getContract.endpoint
  );

export const useRelinkContractEnrollments =
  genericMutationWithId<contractsApis.RelinkContractEnrollments>(
    contractsApis.relinkContractEnrollments,
    contractsApis.searchContracts.endpoint,
    contractsApis.getContract.endpoint
  );

export const useAddContractInvoice = genericMutationWithId<contractsApis.AddContractInvoice>(
  contractsApis.addContractInvoice,
  contractsApis.searchContracts.endpoint,
  contractsApis.getContract.endpoint,
  contractsApis.getUnmappedInvoices.endpoint,
  contractsApis.getSmartBillSyncStatus.endpoint
);

export const useSyncContract = genericMutationWithIdParams<contractsApis.SyncContract>(
  contractsApis.syncContract,
  contractsApis.searchContracts.endpoint,
  contractsApis.getContract.endpoint,
  contractsApis.getUnmappedInvoices.endpoint,
  contractsApis.getSmartBillSyncStatus.endpoint
);

export const useGetUnmappedInvoices = genericQuery<contractsApis.GetUnmappedInvoices>(
  contractsApis.getUnmappedInvoices
);

export const useUpdateClientInvoice =
  genericMutationWithIdParams<contractsApis.UpdateClientInvoice>(
    contractsApis.updateClientInvoice,
    contractsApis.getUnmappedInvoices.endpoint,
    contractsApis.searchContracts.endpoint,
    contractsApis.getContract.endpoint,
    contractsApis.getSmartBillSyncStatus.endpoint
  );

export const useSyncClientInvoice = genericMutationWithIdParams<contractsApis.SyncClientInvoice>(
  contractsApis.syncClientInvoice,
  contractsApis.getUnmappedInvoices.endpoint,
  contractsApis.searchContracts.endpoint,
  contractsApis.getContract.endpoint
);

export const useTriggerSmartBillSync = genericMutation<contractsApis.TriggerSmartBillSync>(
  contractsApis.triggerSmartBillSync,
  contractsApis.getSmartBillSyncStatus.endpoint
);

export const useGetSmartBillSyncStatus = genericQuery<contractsApis.GetSmartBillSyncStatus>(
  contractsApis.getSmartBillSyncStatus
);

export const useTriggerPandaDocSync = genericMutation<contractsApis.TriggerPandaDocSync>(
  contractsApis.triggerPandaDocSync,
  contractsApis.getPandaDocDocuments.endpoint,
  contractsApis.searchContracts.endpoint
);

export const useGetPandaDocDocuments = genericQueryWithParams<contractsApis.GetPandaDocDocuments>(
  contractsApis.getPandaDocDocuments
);

export const useLinkPandaDocDocument = genericMutationWithId<contractsApis.LinkPandaDocDocument>(
  contractsApis.linkPandaDocDocument,
  contractsApis.getPandaDocDocuments.endpoint,
  contractsApis.searchContracts.endpoint
);

export const usePreviewContractImport = genericMutation<contractsApis.PreviewContractImport>(
  contractsApis.previewContractImport
);

export const useCommitContractImport = genericMutation<contractsApis.CommitContractImport>(
  contractsApis.commitContractImport,
  contractsApis.searchContracts.endpoint,
  contractsApis.getSmartBillSyncStatus.endpoint
);
